import { isNumber as isRemedaNumber } from 'remeda';

interface IFormatMoneyProps {
  value: string | number;
  currency?: string;
  minimumFractionDigits?: number;
}

export function formatMoney({
  value,
  currency = 'USD',
  minimumFractionDigits = 2,
}: IFormatMoneyProps): string {
  if (value !== 0 && !value) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    currency,
    style: 'currency',
    minimumFractionDigits,
  }).format(Number(value));
}

export function formatNumber(value: string | number): string {
  if (value !== 0 && !value) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
  }).format(Number(value));
}

export function isNumber(value: string | number): boolean {
  return value === 0 || (value !== '' && isRemedaNumber(Number(value)));
}
